import clsx from 'clsx';
import type { FleetDevice } from 'src/api/endpoints/cloudEnterprise.types';
import { DeviceIcon } from 'src/components/DeviceIcon';
import { fleetMemberRowHelpers } from './fleetMemberRowHelpers';

export function EnterpriseDeviceIcon({
  device,
  active = false,
}: {
  device: FleetDevice;
  active?: boolean;
}) {
  const showComplianceStatus =
    fleetMemberRowHelpers.isDeviceNonCompliant(device);

  return (
    <div
      className={clsx('shrink-0 rounded-[5px] py-2 hover:bg-paper-6', {
        'bg-paper-8': active,
      })}
    >
      {showComplianceStatus && (
        <div className="absolute top-[-1px] right-0 size-[10px] rounded-full border-2 border-paper-2 bg-feedback-red-500" />
      )}
      <DeviceIcon device={device} />
    </div>
  );
}
